export const BRAND = {
    name: "LS Design & Consulting",
    short: "LS",
    email: "info@ls-dc.de",
    slogan: "Individuelle Webseiten & smarte Beratung für Ihren Erfolg",
    logo: "https://customer-assets.emergentagent.com/job_d27451e4-6e7c-4a6e-8844-efb8e3c0fa98/artifacts/rjhemz6g_Logo.jpg",
    instagram: "https://www.instagram.com/ls.designconsulting",
    instagramHandle: "@ls.designconsulting",
};

export const NAV = [
    { label: "Über uns", href: "#about" },
    { label: "Leistungen", href: "#services" },
    { label: "Kontakt", href: "#contact" },
];

export const IMAGES = {
    hero: "https://static.prod-images.emergentagent.com/jobs/d27451e4-6e7c-4a6e-8844-efb8e3c0fa98/images/db980725eeabc91fa0e4179cca0c5f51e5b8632630a0e3aaefc3fda6d23e3f6f.png",
    about: "https://static.prod-images.emergentagent.com/jobs/d27451e4-6e7c-4a6e-8844-efb8e3c0fa98/images/f459399f2d034348c6b0786089015acacbccb750c4ce07928c9235441b6b511c.png",
    project1:
        "https://images.unsplash.com/photo-1750056393331-82e69d28c9d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHx3ZWIlMjBkZXNpZ24lMjBtb2NrdXB8ZW58MHx8fHwxNzc3ODI5NTYxfDA&ixlib=rb-4.1.0&q=85",
    project2:
        "https://images.pexels.com/photos/3637943/pexels-photo-3637943.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    consulting:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzc3ODI5NTYxfDA&ixlib=rb-4.1.0&q=85",
};

export const PROJECTS = [
    {
        id: 1,
        title: "Atelier Nord",
        category: "Webdesign · Branding",
        year: "2024",
        image: IMAGES.project1,
        description:
            "Eine editoriale Markenwebsite für ein Architekturstudio – minimalistisch, typografisch, mit fokussierter Projektdarstellung.",
    },
    {
        id: 2,
        title: "Halden & Söhne",
        category: "Strategie · Consulting",
        year: "2024",
        image: IMAGES.project2,
        description:
            "Digitale Neupositionierung eines Traditionsunternehmens mit umfassender Analyse und Roadmap für die kommenden 24 Monate.",
    },
    {
        id: 3,
        title: "Monde Studio",
        category: "Webdesign · E-Commerce",
        year: "2023",
        image: IMAGES.consulting,
        description:
            "Ruhige, kuratierte Shop-Experience mit Fokus auf Produktgeschichten und konversionsstarke Interaktionen.",
    },
];

export const SERVICES = [
    {
        number: "01",
        title: "Webdesign",
        tagline: "Maßgeschneiderte Webseiten, die wirken.",
        description:
            "Moderne, individuell gestaltete Webseiten – konzipiert, designed und entwickelt auf Ihr Unternehmen zugeschnitten. Performance, Ästhetik und Klarheit gehen Hand in Hand.",
        points: [
            "Corporate Websites & Landing Pages",
            "UX/UI Design & Prototyping",
            "Technische Entwicklung (Responsive, SEO-ready)",
            "Content-Strategie & Redaktion",
        ],
    },
    {
        number: "02",
        title: "Consulting",
        tagline: "Klarheit für Ihre digitale Präsenz.",
        description:
            "Strategische Beratung zur Optimierung Ihrer digitalen Präsenz. Wir analysieren, priorisieren und begleiten Sie vom ersten Workshop bis zur erfolgreichen Umsetzung.",
        points: [
            "Digital-Strategie & Positionierung",
            "Website-Audit & Optimierung",
            "Customer Journey Mapping",
            "Workshops & Coaching",
        ],
    },
];

export const STATS = [
    { value: "100%", label: "Individuell entwickelt" },
    { value: "DE", label: "Made in Germany" },
];
